<template>
  <div id="app">
    <Header></Header>
    <router-view/>
    <Footertwo></Footertwo>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App',
  mounted(){
    // this.$store.commit('setLang',0)
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/App.vue